import { createBrowserRouter, RouterProvider } from 'react-router';
import { AppProviders } from './providers/AppProviders';
import { queryClient } from './providers/queryClient';
import { connectSession } from './providers/sessionBridge';
import { createAppRoutes } from './router/routes';

const router = createBrowserRouter(createAppRoutes());

connectSession(queryClient, (to) => router.navigate(to, { replace: true }));

export function App() {
  return (
    <AppProviders queryClient={queryClient}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
